<template>
  <qx-card-form title="客户信息" :defaultContentShow="false">
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="120px">
      <span slot="cmMileageNumberTip">
        <span class="error" style="margin-left: 16px" v-show="calcIng">距离计算中...</span>
      </span>
    </qx-custom-form>
    <button @click="getDataTest" class="test-btn">测试提交参数</button>
  </qx-card-form>
</template>
<script>
export default {
  data () {
    return {
      calcIng: false,
      otherFormData: {
        type: '',
      },
      baseForm: {
        inline: true,
        form: [
          {
            label: '客户公里数',
            value: 'cmMileageNumber',
            type: 'input',
            width: '240px',
            onChange: () => {
              this.$emit('calCostPrice', 'customerForm');
            },
          },
          {
            label: '客户联系人',
            value: 'linkName',
            type: 'input',
          },
          {
            label: '联系人电话',
            value: 'linkPhone',
            type: 'input',
          },
          {
            label: '客户地址',
            value: 'address',
            type: 'input',
          },
          {
            label: '客户合同',
            value: 'contract',
            type: 'img',
            accept: 'image/*',
            fileSize: 51200000000,
            attr: {
              limit: 1,
            },
            default: [],
          },
        ],
      },
    };
  },
  methods: {
    async getDataTest () {
      this.sub();
    },
    setDistant (distance) {
      // 客户公里数
      this.$refs.baseForm.setVal('cmMileageNumber', distance);
    },
    // 获取变更的信息
    setData (data) {
      // 把获取过来的信息设置到表单里面
      let contract = this.$refs.baseForm.getVal('contract');
      // 如果有合同
      if (data.customer.contractId) {
        contract = [{
          id: data.customer.contractId,
          url: data.customer.contractUrl,
        }];
      }
      const info = {
        cmMileageNumber: data.line.cmMileageNumber,
        linkName: data.customer.lineName,
        linkPhone: data.customer.linePhone,
        address: data.customer.address,
        contract,
      };
      this.otherFormData.type = data.customer.type;
      this.$refs.baseForm.setVal('form', info);
    },
    async handleSubData (cache) {
      let formData = null;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        // 这里处理的格式必须和详情接口返回的一样
        formData = {
          ...formData,
          ...this.otherFormData,
        };
      }
      return formData;
    },
    async cacheData () {
      const res = await this.handleSubData(true);
      return res;
    },
    async sub () {
      let formData = await this.handleSubData();
      if (formData) {
        let customerInfo = {};
        for (let name in formData) {
          if (formData[name] !== null && formData[name] !== undefined) {
            if (name === 'contract') {
              if (formData[name].length) {
                customerInfo['customerInfo.' + name + 'No'] = formData[name][0].id;
                customerInfo['customerInfo.' + name + 'Id'] = formData[name][0].id;
                customerInfo['customerInfo.' + name + 'Url'] = formData[name][0].url;
              }
            } else {
              customerInfo['customerInfo.' + name] = formData[name];
            }
          }
        }
        formData = customerInfo;
      }
      return formData;
    },
    setDetailData (data) {
      if (data.orderScheduler) {
        data.cmMileageNumber = data.orderScheduler.distance / 1000;
        if (data.orderScheduler.clientContractId) {
          data.contract = [{
            url: data.orderScheduler.clientContractUrl,
            id: data.orderScheduler.clientContractId,
          }];
        }
      }

      if (data.orderGoods) {
        data.linkName = data.orderGoods.linkName;
        data.linkPhone = data.orderGoods.linkPhone;
        data.address = data.orderGoods.address;
        this.otherFormData.type = data.orderGoods.custType;
      }
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'disabled',
        value: !!this.$route.query.id,
        names: ['contract'],
      });
    },
    init (data = {}) {
      this.$refs.baseForm.reset();
      this.setDetailData(data);
      this.$refs.baseForm.setVal(data);
      this.setFormVal(this.otherFormData, data);
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
